var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-typography',{attrs:{"value":_vm.label,"caption":""}}),_c('base-text-area',{model:{value:(_vm.textValue),callback:function ($$v) {_vm.textValue=$$v},expression:"textValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }